import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { LocalDateTimePipe } from '../../../../../../Shared/_pipes/local-date-time';
import { TimerComponent } from 'src/app/Shared/components/timer/timer.component';
import { RouterLink } from '@angular/router';
import { LocalizedNamePipe } from 'src/app/Shared/pipes/localized-name.pipe';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-buyer-catalogue-pageheader',
        standalone: true,
templateUrl: './buyer-catalogue-pageheader.component.html',
    styleUrls: ['./buyer-catalogue-pageheader.component.scss'],
    imports: [LocalDateTimePipe, TimerComponent, RouterLink, TranslatePipe, LocalizedNamePipe]
})
export class BuyerCataloguePageheaderComponent {
  @Input() auctionInfo: any = '';
  @Input() img!: string;
  @Input() type!: string;
  @Input() consignorName!: string;
  @Input() consignorId!: string;
  @Input() isLoading: any;
  @Input() gradualEnding: any;

  @Output() actionFired: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    // Set the target date and time for the auction to start
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  fireTimeEnded() {
    this.actionFired.emit({
      detail: {
        propagation: false,
        action: 'time_ended',
        id: this.auctionInfo?.auction?.id,
      },
    });
  }
}
